import {useQuery} from "@tanstack/react-query";
import * as api from "../../services/api";


/*
 * Query to get all the accommodation of a user
 */
export const useAccommodationsQuery = () => {
    return useQuery({
        queryKey: ["accommodations"],
        queryFn: () => api.Accommodations.getAllAccommodations(),
    });
}